<script setup lang="ts">
import Content from '@desktop/views/Relation/Sports/components/RelationView/Content.vue'

import MainSummary from './Main/MainSummary/MainSummary.vue'
import PitchWithIncidents from './Main/PitchWithIncidents/PitchWithIncidents.vue'
</script>

<template>
  <Content asideBreakpoint="sm">
    <template #main>
      <MainSummary />
      <PitchWithIncidents />
    </template>
  </Content>
</template>
